export const getFullView = (a11yWizardAdapter, ruleGroups, detectedIssuesNumber, manualTasksNumber) => {
  if (ruleGroups === undefined || detectedIssuesNumber === undefined || manualTasksNumber === undefined) {
    return JSON.stringify({});
  }
  const result = {
    page_list: [],
    status: [{
      detected_issues: detectedIssuesNumber,
      manual_tasks: manualTasksNumber
    }]
  };
  ruleGroups.forEach(group => {
    const groupIssues = group.ruleResults.filter(rule => !rule.status).length;
    result.page_list.push({
      issues: groupIssues,
      page_id: group.groupId,
      ...(group.groupId === a11yWizardAdapter.getHomePageId() ? {
        is_home_page: true
      } : {})
    });
  });
  return JSON.stringify(result);
};
//# sourceMappingURL=get-full-view-bi-param.js.map